import { useState, useEffect } from 'react'

export function useVisibilityChange() {
  // Estado para saber si la pantalla está bloqueada o no.
  // Lo inicializamos basándonos en el estado actual de visibilidad.
  const [isVisible, setIsVisible] = useState(document.visibilityState === 'visible')

  useEffect(() => {
    // Función que se ejecutará cuando cambie la visibilidad de la página.
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'hidden') {
        // El usuario bloqueó el teléfono o cambió de pestaña.
        setIsVisible(false)
      } else {
        // El usuario desbloqueó el teléfono o volvió a la pestaña.
        setIsVisible(true)
        // Aquí podés ejecutar la lógica que necesites al desbloquear.
        // Por ejemplo, actualizar datos, reiniciar una animación, etc.
      }
    }

    // Agregamos el listener para el evento 'visibilitychange'.
    document.addEventListener('visibilitychange', handleVisibilityChange)

    // Función de limpieza: se ejecuta cuando el componente se desmonta.
    // Es importante para remover el listener y evitar problemas de memoria.
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange)
    }
  }, []) // El array vacío asegura que el efecto se ejecute solo una vez (al montar).

  return { isVisible }
}
